import GoogleMaps from './google-maps';

export default GoogleMaps;